// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentContainer } from "../../framework/components/ComponentContainer";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { DialogSettings, CardSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { s_bg_placeholder, s_black_square, s_popup_darkblue_rect, s_popup_top, s_popup_bottom, s_btn_green, s_buttonpower_effect, s_buttonpower_glow, s_card_big } from "../AssetDefinitions/ImageDefinitions";
import { EventSystem } from "../Events/EventSystem";
import { Events } from "../Events/Events";
tgfSettings.dialogDefaults.TerenceRewardDialog = {
    width: 800,
    height: 550,
    font: DialogSettings.textFont,
    smallFont: DialogSettings.textFontSmall,
    buttonFont: DialogSettings.buttonFont,
    includeBackground: false,
    components: [] // The additional components to add
};
export var TerenceRewardDialog = function (properties) {
    "use strict";
    this.name = "TerenceRewardDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.TerenceRewardDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    this.onDisconnect = this.close.bind(this, false);
    EventSystem.subscribe(Events.DISCONNECTED, this.onDisconnect);
};
// Inherit the base dialog
tgfDialogs.inherit(TerenceRewardDialog, DialogBase);
TerenceRewardDialog.prototype.doPrepare = function () {
    "use strict";
    if (this.includeBackground) {
        this.lobbyBG = new ComponentPicture({
            image: s_bg_placeholder,
            xScale: 2,
            yScale: 2
        });
        this.addComponent(this.lobbyBG);
    }
    this.transparentBlack = new ComponentButton({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.7,
        image: s_black_square
    });
    this.addComponent(this.transparentBlack);
    this.background = new ComponentPicture({
        image: s_popup_darkblue_rect,
        createFromSlices: true,
        sliceMarginsArray: [55, 55, 55, 55],
        width: this.width,
        height: this.height,
        x: -(this.width / 2),
        y: -(this.height / 2)
    });
    this.transparentBlack.addComponent(this.background);
    this.headerBackground = new ComponentPicture({
        image: s_popup_top,
        x: tgfGraphics.areaWidth / 2,
        y: -this.height / 2 + tgfGraphics.areaHeight / 2
    });
    this.addComponent(this.headerBackground);
    this.addComponent(new ComponentPicture({
        image: s_popup_bottom,
        x: tgfGraphics.areaWidth / 2,
        y: this.height / 2 - 20 + tgfGraphics.areaHeight / 2
    }));
    this.headerLabel = new ComponentLabel({
        text: tgfDictionary.getText("REWARD_POPUP_HEADER"),
        font: this.font,
        y: 4
    });
    this.headerBackground.addComponent(this.headerLabel);
    this.centerLabel = new ComponentLabel({
        text: String.format(tgfDictionary.getText("REWARD_POPUP_BODY_2_TEXT"), CardSettings.terenceTimerDuration),
        font: this.font,
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 - this.height / 2 + 100,
        splitLines: true,
        width: this.width - 20,
    });
    this.addComponent(this.centerLabel);
    this.initCard();
    this.buttonContainer = new ComponentContainer({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 + this.height / 2 - 100
    });
    this.addComponent(this.buttonContainer);
    this.acceptButton = new ComponentButton({
        image: s_btn_green,
        text: tgfDictionary.getText("BTN_REWARD_POPUP"),
        fontUp: this.buttonFont,
        onClick: this.onAccept.bind(this),
    });
    this.buttonContainer.addComponent(this.acceptButton);
    // AngryAnalytics.reportScreen("opt_in");
};
TerenceRewardDialog.prototype.initCard = function () {
    this.cardContainer = new ComponentContainer({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
    });
    this.addComponent(this.cardContainer);
    this.cardBG = new ComponentPicture({
        image: s_buttonpower_effect,
        xScale: 1.5,
        yScale: 1.5,
        alpha: 0.5
    });
    this.cardContainer.addComponent(this.cardBG);
    this.cardGlow = new ComponentPicture({
        image: s_buttonpower_glow,
        x: 20,
        y: 20,
        xScale: 2,
        yScale: 2,
        alpha: 0.5
    });
    this.cardContainer.addComponent(this.cardGlow);
    this.card = new ComponentPicture({
        image: s_card_big,
        angle: -(1 / 18 * Math.PI),
        xScale: 0.5,
        yScale: 0.5
    });
    this.cardContainer.addComponent(this.card);
};
TerenceRewardDialog.prototype.onAccept = function () {
    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
    this.close();
};
TerenceRewardDialog.prototype.close = function () {
    this.hide();
    this.free();
    EventSystem.unsubscribe(Events.DISCONNECTED, this.onDisconnect);
    if (this.onClose) {
        this.onClose();
    }
};
TerenceRewardDialog.prototype.toggleInput = function (enable) {
    if (enable) {
        this.activate();
    }
    else {
        this.deactivate();
    }
};
TerenceRewardDialog.prototype.handleEndStep = function (deltaTime) {
    TerenceRewardDialog.uber.handleEndStep.call(this);
    this.cardBG.setAngle(this.cardBG.angle + deltaTime / 1000);
};
